import { createContext, type ReactNode, useContext } from 'react';

import type { TableSelection } from '@/common/types';

export type TableSelectionContextType<T> = {
  currentPageSelection: T[];
  selectableData: T[];
  checkAll: () => void;
  check: (item: T) => void;
  uncheckAll: () => void;
  uncheck: (item: T) => void;
  isChecked: (item: T) => boolean;
  toggleSelection: () => void;
  toggleSelectAll: () => void;
  selection?: TableSelection<T>;
  selectable?: {
    byField: keyof T;
    aside?: ReactNode;
    total: number;
    rowDisabled?: (row: T) => boolean;
    allPagesSelectable?: boolean;
  };
};

export const defaultSelf: TableSelectionContextType<any> = {
  currentPageSelection: [],
  selectableData: [],
  checkAll: () => null,
  check: () => null,
  uncheckAll: () => null,
  uncheck: () => null,
  toggleSelection: () => null,
  toggleSelectAll: () => null,
  isChecked: () => false,
};

export const TableSelectionContext = createContext<TableSelectionContextType<any>>(defaultSelf);

export function useTableSelectionCtx<T>() {
  return useContext(TableSelectionContext) as TableSelectionContextType<T>;
}
